export const ADMIN_ROLES = ['admin', 'owner', 'manager', 'staff'];

export const ALL_PERMISSIONS = ['products', 'inventory', 'orders', 'customers', 'categories', 'coupons', 'gift_finder', 'home_cms', 'settings', 'analytics', 'admin_users'];

export const PERMISSION_LABELS = {
  products: 'Products', inventory: 'Inventory', orders: 'Orders', customers: 'Customers',
  categories: 'Categories', coupons: 'Coupons', gift_finder: 'Gift Finder', home_cms: 'Home / CMS',
  settings: 'Settings', analytics: 'Analytics', admin_users: 'Admin Users',
};

export const ROLE_DEFAULTS = {
  manager: ['products', 'inventory', 'orders', 'customers', 'categories', 'coupons', 'gift_finder', 'analytics'],
  staff: ['orders', 'inventory'],
};

export const ROLE_LABELS = { admin: 'Owner', owner: 'Owner', manager: 'Manager', staff: 'Staff' };

export const isAdminRole = (u) => ADMIN_ROLES.includes(u?.role);

export const permsOf = (u) => {
  if (!u || !isAdminRole(u)) return [];
  if (u.role === 'admin' || u.role === 'owner') return ALL_PERMISSIONS;
  return Array.isArray(u.permissions) ? u.permissions : (ROLE_DEFAULTS[u.role] || []);
};
